export default {"src":"/_next/static/media/topbarsaved.4b145af6.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};